import type { App } from 'vue'

import { abilitiesPlugin } from '@casl/vue'
import type { Rule } from './ability'
import { ability } from './ability'

/**
 * Installs the shared ability rather than a private one.
 *
 * `ability.ts` has always exported an instance; this plugin used to build its own and
 * provide that instead, which left the exported one unused and the provided one reachable
 * only from inside a component. Anything outside a component that learned the session had
 * changed - the token listener, for one - could write the cookie but had no way to tell the
 * live ability about it, so the nav stayed as it was until the page was loaded twice.
 */
export default function (app: App) {
  const userAbilityRules = useCookie<Rule[]>('userAbilityRules')

  ability.update(userAbilityRules.value ?? [])

  app.use(abilitiesPlugin, ability, {
    useGlobalProperties: true,
  })
}
